<template>
  <div class="ContractCancel">
    <div class="page-title">{{ title }}</div>
    <div>
      <ATable
        ref="table"
        max-height="750px"
        :data="items"    
        :placeholder="placeholder"    
        :search_field="search_field"
        border
        hide-button-insert
        hide-pagination
        @row-click="handleClickRow"
        @clicked-create="handleClickedCreate"
      >
        <div slot="search">
          <div class="inline">
            <APeriodSelector ref="period" @change="handleChangePeriod" />
          </div>
          <div class="inline">
            <el-button
              type="primary"
              size="mini"
              round
              v-shortkey="['f5']"
              @shortkey.native="handleClickSearch"
              @click="handleClickSearch"
            >검색(F5)</el-button>
          </div>
        </div>
        <el-table-column
          type="index"
          label="No"
          :index="handleIndex"
          :width="$width.index"
        />
        <el-table-column
          prop="contract_date"
          label="수주일"
          :width="$width.date"
        />
        <el-table-column prop="code" label="수주번호" width="100" />
        <el-table-column
          prop="customer_name"
          label="거래처"
          width="100"
          show-overflow-tooltip
        />
        <el-table-column
          prop="product_name"
          label="품목"
          min-width="120"
          show-overflow-tooltip
        />
        <el-table-column 
          prop="destination" 
          label="도착지" 
          show-overflow-tooltip 
        />
        <el-table-column
          prop="amount"
          label="수량"
          class-name="cell-number"
          :width="$width.amount"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="cost"
          label="단가"
          class-name="cell-number"
          :width="$width.price"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="supply_price"
          label="공급가액"
          class-name="cell-number"
          :width="$width.price"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="tax"
          label="세액"
          class-name="cell-number"
          :width="$width.price"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="delivery_date"
          label="납품일"
          :width="$width.date"
        />
        <el-table-column
          prop="created_user_name"
          :label="$t('lang.created_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="modified_user_name"
          :label="$t('lang.modified_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="created_at"
          :label="$t('lang.created_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column
          prop="modified_at"
          :label="$t('lang.modified_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
      </ATable>
    </div>
    <el-dialog
      custom-class="form-dialog"
      top="0"
      width="1200px"
      :title="title"
      :visible.sync="dialog_visible"
      :close-on-click-modal="false"
      :before-close="beforeClose"
      destroyOnClose
      @opened="handleOpened"
    >
      <ContractForm 
        ref="form" 
        v-if="dialog_visible"
        :data="form_data" 
        deleted
        @completed="handleCompleted" 
      />
    </el-dialog>
  </div>
</template>

<script>
import { form_container } from "@/common/mixins/form_container";
import ContractForm from "./ContractForm";

export default {
  name: "ContractCancel",
  mixins: [form_container],
  components: { ContractForm },
  data() {
    return {
      title: this.$t("title.contract_cancel"),
      search_field: ["code", "customer_name", "product_name"],
      placeholder: '수주번호, 거래처, 품목',
      search: {
        keyword: "",
        status: []
      },
      items: [],
      dialog_visible: false,
      dialog_visible2: false,
      isShowSearchDetail: false,
      form_data: undefined,
      statuses: [
        { value: "0", label: "진행" },
        { value: "1", label: "수주" },
        { value: "2", label: "취소" }
      ],
      period: {},
    };
  },
  computed: {
    searchTags: function() {
      let tags = [];
      let tag = {};
      tag.name = this.util.getPeriodText(this.search.period);
      tag.fixed = true;
      tags.push(tag);
      if (this.search.keyword.length > 0) {
        tag = {};
        tag.name = "검색어: " + this.search.keyword;
        tags.push(tag);
      }
      if (this.search.status.length > 0) {
        tag = {};
        tag.name = "상태: " + this.search.keyword;
        tags.push(tag);
      }
      return tags;
    }
  },  
  methods: {
    handleChangePeriod(value) {
      this.period = value;
      this.handleClickSearch();
    },
    handleClickSearch() {
      if (!this.period.valid) { return; }
      this.loadData();
    },
    loadData() {
      this.loading = true;
      this.api.listContractCancel(this.period).then(res => {
        this.loading = false;
        if (res.error !== this.system.noError) {
          this.util.notify_error(this, this.title, res.message);
          return;
        }
        this.items = res.data;
        for (let i = 0; i < this.items.length; ++i) {
          this.dataArrange(i);
        }
      });
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleSearchDetail() {
      this.isShowSearchDetail = !this.isShowSearchDetail;
      if (!this.isShowSearchDetail) {
        return;
      }
      this.$nextTick(() => {
        this.$refs.keyword.$refs.input.focus();
      });
    },
    /** 데이터 선택 */
    handleClickRow(data) {
      this.openDialog(data);
    },
    /** 신규 등록*/
    handleClickedCreate() {
      this.form_data = undefined; //추가생성시 초기화
      // this.openDialog();
      this.$router.push("/sale/contract_reg");
    },

    /**  폼 처리 완료 */
    handleCompleted(action, message) {
      this.dialog_visible = false;
      this.form_data = undefined;

      switch (action) {
        case "create":
        case "delete":
          this.handleClickSearch();
          this.$refs.table.initCurrentPage();
          break;
        case "update":
          this.loadData();
          break;
      }

      if (!message) {
        return;
      }
      this.$notify(message);
    },

    dataArrange(index) {
      this.items[index].amount = 0;
      this.items[index].tax = 0;
      this.items[index].cost = 0;
      this.items[index].supply_price = 0;
      for (let j = 0; j < this.items[index].details.length; ++j) {
        this.sumCalculation(index, j);
      }
      this.productNaming(index);
    },
    sumCalculation(index, j) {
      this.items[index].amount += this.items[index].details[j].amount;
      this.items[index].tax += this.items[index].details[j].tax;
      this.items[index].cost += this.items[index].details[j].cost;
      this.items[index].supply_price += this.items[index].details[
        j
      ].supply_price;
    },
    productNaming(index) {
      if (this.items[index].details.length > 1) {
        this.items[index].product_name = this.items[index].details[0].product_name + " 외 " + (this.items[index].details.length - 1) + "건";
      } else {
        this.items[index].product_name = this.items[index].details[0].product_name;
      }
    },
    /** 다이얼로그 팝업 */
    openDialog(data) {
      let clone = data ? this.util.looseClone(data) : undefined;
      this.form_data = clone;
      this.dialog_visible = true;
    },
    resolveTypeFlag(value) {
      return this.system.options.resolve_customer_type_flag(value);
    },
  }
};
</script>
<style lang="scss" scoped>
.clear-float {
  clear: both;
}

.search-head {
  .left-search-head {
    width: calc(100% - 480px);
    padding-right: 10px;
    box-sizing: border-box;
    float: left;
  }

  .search-timer-title {
    display: inline-block;
    text-align: center;
    width: 100px;
  }

  .right-search-head {
    width: 480px;
    float: left;
  }
}

.editer-box {
  margin-top: 20px;
  border: 1px solid #eee;

  .editer-box-head {
    padding-left: 20px;
    border: 1px solid #eee;
    line-height: 48px;

    .editer-box-title {
      font-weight: 700;
    }
  }

  .editer-box-body {
    padding: 20px 30px;
    box-sizing: border-box;
  }

  .split-line {
    clear: both;
    margin: 0 5px;
    height: 2px;
    background: #eee;
  }

  .editer-box-foot {
    padding: 10px;
  }
}

.search-keyword {
  width: 300px;
  margin-right: 20px;
}

.search-status {
  width: 200px;
  margin-right: 20px;
}
</style>
